import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
	separator: {
		height: "1.2em",
		alignSelf: "center",
		borderRight: "1px solid var(--color-grey-light)"
	}
});
